<template>
  <div class="model">
    <div class="loading" v-if="loading">
      Loading...
    </div>

    <div v-if="error" class="error">
      {{ error }}
    </div>

    <div v-if="model" class="model">
      <div class="content">
        <div class="sidebar">

          <h1>
            <span>{{model.name}}</span>
            <span v-if="model.birthday" class="model__age">{{ model.age }}</span>
          </h1>
          <div class="safe-image">
            <div class="model__headshot" v-bind:style="[{ backgroundImage: `url(${imageUrlFor(model.imageHeadshot).width(480)})`}]"></div>
          </div>
          <div class="model__actions">
            <a class="edit-button" target="_blank" v-if="model._id" :href="`http://localhost:3333/desk/model;${model._id}`">Edit</a>
            <img v-if="model.favorite" class="favorite-icon" src="../assets/favorite-true.png"/>
            <img v-else class="favorite-icon" src="../assets/favorite-false.png"/>
          </div>

          <div v-if="model.aliases" class="model__aliases">
            <h6 class="model__label">Aliases</h6>
            <ul class="model__detail-list" v-if="model.aliases" >
              <li class="model__detail" v-for="alias_name in model.aliases">
                <router-link class="scene-tile__alias-link" target="_blank" :to="{name: 'aliases', params: {alias: alias_name.toLowerCase()}}">
                  {{alias_name}}
                </router-link>
              </li>
            </ul>
          </div>
          <div v-if="model.birthday" class="model__detail-group model__birthday">
            <h6 class="model__label">Birthday</h6>
            <div class="model__detail">{{new Date(model.birthday).toLocaleDateString('en-us', { year:"numeric", month:"long", day:"numeric"})}}</div>
          </div>
          <div v-if="model.nationality" class="model__detail-group model__nationality">
            <h6 class="model__label">Nationality</h6>
              <div class="model__detail" v-if="model.nationality">{{model.nationality}}</div>
          </div>
          <div v-if="model.ethnicity" class="model__detail-group model__ethnicity">
            <h6 class="model__label">Ethicity</h6>
            <div class="model__detail">{{model.ethnicity}}</div>
          </div>
          <div v-if="model.imageSkin" class="model__detail-group model__skin">
            <h6 class="model__label">Skin Tone</h6>
            <div class="model__detail"><img class="model__detail model__detail-skin" :src="imageUrlFor(model.imageSkin).ignoreImageParams().width(50)"/>
          </div>
          </div>
          <div v-if="model.bust && model.cup" class="model__detail-group model__measurements">
            <h6 class="model__label">Measurements</h6>
            <div class="model__detail">{{model.bust}}{{model.cup}}<span v-if="model.waist">-{{model.waist}}</span><span v-if="model.hip">-{{model.hip}}</span></div>
          </div>
          <div v-if="model.ethnicity" class="model__detail-group model__height">
            <h6 class="model__label">Height</h6>
            <div class="model__detail">{{model.height}}</div>
          </div>
          <div v-if="model.ethnicity" class="model__detail-group model__weight">
            <h6 class="model__label">Weight</h6>
            <div class="model__detail">{{model.weight}}</div>
          </div>
          <div v-if="model.ethnicity" class="model__detail-group model__breasts">
            <h6 class="model__label">Breasts</h6>
            <div class="model__detail">{{model.breasts}}</div>
          </div>
          <div v-if="model.ass" class="model__detail-group model__ass">
            <h6 class="model__label">Ass</h6>
            <div class="model__detail">{{model.ass}}</div>
          </div>
          <div v-if="model.ethnicity" class="model__detail-group model__eyes">
            <h6 class="model__label">Eyes</h6>
            <div class="model__detail" >{{model.eyes}}</div>
          </div>
          <div v-if="model.ethnicity" class="model__detail-group model__hair">
            <h6 class="model__label">Hair</h6>
            <div class="model__detail">{{model.hair}}</div>
          </div>
          <div v-if="model.ethnicity" class="model__detail-group model__shoesize">
            <h6 class="model__label">Shoe Size</h6>
            <div class="model__detail">{{model.shoeSize}}</div>
          </div>
          <div v-if="model.description" class="model__detail-group model__description">
            <h6 class="model__label">Description</h6>
            <div class="model__rich-text"></div>
          </div>
        </div>
        <div class="main-content">
          <ul class="tab-list">
            <li class="tab tab--active" data-handle="scenes">
              <button @click="setTabContent('scenes')">Scenes ({{ model.scenes.length }})</button>
            </li>
            <li class="tab" data-handle="galleries">
              <button @click="setTabContent('galleries')">Galeries ({{ model.galleries.length }})</button>
            </li>
            <li class="tab" data-handle="anatomy">
              <button @click="setTabContent('anatomy')">Anatomy</button>
            </li>
          </ul>
          <div class="tab-content" data-handle="anatomy">
            <ul class="image-list">
              <li v-if="model.imageBody" class=" list__item">
                <a :href="imageUrlFor(model.imageBody)" target="_blank">
                  <div class="image-container safe-image">
                    <img class="detail-image imageBody" :src="imageUrlFor(model.imageBody).ignoreImageParams().width(480)"/>   
                  </div>   
                </a>          
                <h6><span>Body</span><span v-if="model.height" class="model__note">{{ model.height }}</span><span v-if="model.weight" class="model__note">{{ model.height }}</span></h6>
              </li>
              <li v-if="model.imageBreasts" class=" list__item">
                <a :href="imageUrlFor(model.imageBreasts).ignoreImageParams()" target="_blank">
                  <div class="image-container safe-image">
                    <img class="detail-image imageBreasts" :src="imageUrlFor(model.imageBreasts).ignoreImageParams().width(480)"/>
                  </div>    
                </a>            
                <h6><span>Breasts</span><span v-if="model.breasts" class="model__note">{{ model.bust }}{{ model.cup }}, {{ model.breasts }}</span></h6>
              </li>
              <li v-if="model.imageVaginaClosed" class=" list__item">
                <a :href="imageUrlFor(model.imageVaginaClosed).ignoreImageParams()" target="_blank">
                  <div class="image-container safe-image">
                    <img class="detail-image vaginaClosed" :src="imageUrlFor(model.imageVaginaClosed).ignoreImageParams().width(480)"/>
                  </div>
                </a>
                <h6>Vagina, external</h6>
              </li>
              <li v-if="model.imageVaginaOpen" class=" list__item">
                <a :href="imageUrlFor(model.imageVaginaOpen)" target="_blank">
                  <div class="image-container safe-image">
                    <img class="detail-image vaginaClosed" :src="imageUrlFor(model.imageVaginaOpen).ignoreImageParams().width(480)"/>
                  </div>
                </a>
                <h6>Vagina, internal</h6>
              </li>
              <li v-if="model.imageAss" class=" list__item">
                <a :href="imageUrlFor(model.imageAss)" target="_blank">
                  <div class="image-container safe-image">
                    <img class="detail-image vaginaClosed" :src="imageUrlFor(model.imageAss).ignoreImageParams().width(480)"/>
                  </div>
                </a>
                <h6>Ass</h6>
              </li>
              <li v-if="model.imageAnus" class=" list__item">
                <a :href="imageUrlFor(model.imageAnus)" target="_blank">
                  <div class="image-container safe-image">
                    <img class="detail-image vaginaClosed" :src="imageUrlFor(model.imageAnus).ignoreImageParams().width(480)"/>
                  </div>
                </a>
                <h6>Anus</h6>
              </li>
              <li v-if="model.imageFuckMe" class=" list__item">
                <a :href="imageUrlFor(model.imageFuckMe)" target="_blank">
                  <div class="image-container safe-image">
                    <img class="detail-image vaginaClosed" :src="imageUrlFor(model.imageFuckMe).ignoreImageParams().width(480)"/>
                  </div>
                </a>
                <h6>Fuck me</h6>
              </li>
            </ul>       
          </div>
          <div class="tab-content" data-handle="galleries">
              <ul class="image-list">
                <li class="gallery-tile list__item" v-for="gallery in model.galleries" :key="gallery._id">
                  <div class="image-container safe-image">
                    <img class="thumbnail" v-if="gallery.galleryLocal.length > 0" :src="imageUrlFor(gallery.galleryLocal[0]).ignoreImageParams().width(480)"/>
                    <img class="thumbnail" v-else :src="imageUrlFor(gallery.galleryLinked[0]).ignoreImageParams().width(480)"/>
                  </div>      
                  <h6><span>Body</span><span v-if="model.height" class="model__note">{{ model.height }}</span><span v-if="model.weight" class="model__note">{{ model.height }}</span></h6>            
                </li>
              </ul>  
          </div>
          <div class="tab-content tab--active" data-handle="scenes">
              <ul class="scene-list">
                <li v-for="scene in model.scenes" class=" list__item" :key="scene._id">
                  <SceneTile :scene='scene'></SceneTile>
                </li>
              </ul>  
          </div>
          
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import sanity from "../sanity";
import imageUrlBuilder from "@sanity/image-url";
import blocksToHtml from "@sanity/block-content-to-html";
import SceneTile from '../components/SceneTile.vue';

const imageBuilder = imageUrlBuilder(sanity);

function _calculateAge(birthday) { 
    var ageDifMs = Date.now() - birthday.getTime();
    var ageDate = new Date(ageDifMs); 
    return Math.abs(ageDate.getUTCFullYear() - 1970);
}

const query = `*[_type == "model" && _id == $id] {
  _id,
  name,
  image,
  name,
  birthday,
  imageHeadshot,
  imageBody,
  imageBreasts,
  imageVaginaClosed,
  imageVaginaOpen,
  imageAss,
  imageAnus,
  imageSkin,
  imageFuckMe,
  aliases,
  nationality,
  ethnicity,
  eyes,
  hair,
  height,
  weight,
  shoeSize,
  breasts,
  ass,
  cup,
  bust,
  waist,
  hip,
  tattoos,
  piercings,
  description,
  linkPornPics,
  linkFreeones,
  tags,
  collections,
  favorite,
  "scenes": *[_type=='scene' && references(^._id)]{
    _id,
    name,
    release,
    models,
    studios,
    thumbnail,
    screencaps,
    models[]->,
    studios[]->,
    favorite
  },
  "galleries": *[_type=='gallery' && references(^._id)]{
    _id,
    name,
    format,
    models,
    galleryLocal,
    galleryLinked
  }
}[0]
`;

export default {
  props: {
    id: {
      type: String
    }
  },
  name: "Model",
  data() {
    return {
      loading: true,
      model: null
    };
  },
  components: {
    SceneTile
  },
  created() {
    this.fetchData();
  },
  watch: {
    $route: "fetchData"
  },
  methods: {
    imageUrlFor(source) {
      return imageBuilder.image(source);
    },
    setTabContent(handle) {
      if (document.querySelector(`.tab.tab--active`)) {
        document.querySelector(`.tab.tab--active`).classList.remove("tab--active");
      }
      if (document.querySelector(`.tab-content.tab--active`)) {
        document.querySelector(`.tab-content.tab--active`).classList.remove("tab--active");
      }
      document.querySelector(`.tab[data-handle="${handle}"]`).classList.add("tab--active");
      document.querySelector(`.tab-content[data-handle="${handle}"]`).classList.add("tab--active");
    },
    fetchData() {
      this.error = this.model = null;
      this.loading = true;
      sanity.fetch(query, { id: this.id }).then(
        model => {
          this.loading = false;
          this.model = model;
          this.model.age = _calculateAge(new Date(this.model.birthday));
        },
        error => {
          this.error = error;
        }
      );
      const serializers = {
        types: {
          description: props => {
            const h = blocksToHtml.h;
            if (!props.node.description) {
              return false;
            }
            const descriptionArray = props.node.description.map(description => {
              return h("div", null, [
                h("p", null, description.description),
                h("span", null, "—")
              ]);
            });
            return h("div", [
              h("h1", null, props.node.description),
              h("div", null, descriptionArray)
            ]);
          }
        }
      };
/*
      sanity.fetch(query, { id: this.id }).then(
        model => {
          this.loading = false;
          this.model = model;
          this.overviewHtml = blocksToHtml({
            blocks: model.description,
            serializers: serializers,
            dataset: sanity.clientConfig.dataset,
            projectId: sanity.clientConfig.projectId
          });
        },
        error => {
          this.error = error;
        }
      );
      */
    }
  }
};
</script>

<style scoped>
.content {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
}
.sidebar {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  grid-column-end: span 2;
  padding: 40px 120px 40px 40px;
}
.sidebar img {
  max-width: 100%;
}
.main-content {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  grid-column-end: span 3;
  top: 0;
  position: sticky;
}
.anatomy {
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 40px 40px 40px 0;
}
h1 {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 0 0 42px;
  padding: 0 0 10px;
  border-bottom: solid 1px var(--color-mono-0);
  font-size: 1rem;
  width: 100%;
}
h1 span {
  font-size: 1.375rem;
  width: auto;
  display: block;
  margin-top: -4px;
}
.list__item {
  width: 100%;
}
.edit-button {
  margin-top: 8px;
  width: 100%;
  text-align: center;
}
.model__age {
  opacity: 0.3;
   margin-left: 12px;
}
.model__detail-list {
  display: block;
  padding: 0;
  margin: 0;
  list-style: none;
}
.model__label {
  display: block;
  margin: 13px 0;
}
.model__detail-group  {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  border-top: solid 1px var(--color-mono-5);
}
.model__detail-group .model__label  {
  width: 50%;
  text-align: left;
}
.model__detail-group .model__detail  {
  width: 50%;
  text-align: left;
}
.model__detail-group .model__detail-skin {
    border-radius: 50px;
    height: 20px;
    width: 20px;
    transform: translateY(3px);
}
.model__detail {
  display: inline;
  text-transform: capitalize;
}
.model__detail:not(:last-child):after {
  display: inline;
  content: ', ';
}
.model__headshot {
  position: relative;
}
.model__actions {
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  margin-top: 12px;
  margin-bottom: 36px;
}
.model__actions img {
  width: 24px;
  height: auto;
  margin-top: 8px;
}
.model__note {
  display: inline-block;
  font-weight: 400;
  margin-left: 8px;
}
.scene-tile__alias-link {
  color: var(--color-mono-0);
  text-decoration: none;
}
.scene-tile__alias-link:not(:last-child) {
  after: ', ';
}
.model-scenes {
  display: grid;
    margin: 0;
    padding: 36px;
    grid-gap: 36px;
    grid-template-columns: 1fr 1fr;
}
.tab-list {
  display: flex;
  list-style: none;
  padding: 0;
  margin: 42px 0 24px;
  font-size: 1rem;
  width: calc(100% - 40px);
  border-bottom: solid 1px var(--color-mono-0);
}
.tab-list .tab {
  position: relative;
  margin-right: 24px;
}
.tab-list button {
  appearance: none;
  background-color: transparent;
  border: 0;
  margin: 0 0 12px 0;
  padding: 0;
  font-size: 1rem;
  font-weight: 600;
  color: var(--color-mono-0);
  transition: color 0.35s ease-in-out;
  cursor: pointer;
}
.tab-list button:hover {
  color: var(--color-mono-0);
}
.tab-list .tab:after {
  content: '';
  position: absolute;
  background-color: var(--ui-secondary-active);
  height: 1px;
  width: 100%;
  left: 0;
  bottom: -1px;
  opacity: 0;
  transition: opacity 0.35s ease-in-out;
}
.tab-list .tab--active:after {
  opacity: 1;
}
.tab-list .tab button:hover {
  color: var(--color-mono-2);
}
.tab-content {
  display: block;
  position: relative;
  width: 100%;
  padding-right: 40px;
}
.tab-content:not(.tab--active) {
  display: none;
}

.scene-list {
  display: grid;
  margin: 0;
  padding: 20px 0 36px;
  grid-gap: 36px;
  grid-template-columns: 1fr;
}
@media (min-width: 1000px) {
  .scene-list {
    grid-template-columns: 1fr 1fr;
  }
}
.scene-list li {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.image-list {
  display: grid;
  width: 100%;
  padding: 0;
  margin: 0;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: wrap;
  padding: 20px 0 40px;
  width: 100%;
  list-style: none;
}
.image-list .list__item {
    width: calc(50% - 1rem);
    height: auto;
}
.image-list .list__item:not(:nth-of-type(2n)) {
  margin-right: 2rem;
}
.image-list .list__item img {
    width: 100%;
    height: auto;
}
.image-list .list__item h6 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 18px;
  font-size: 0.875rem;
}
.image-list .list__item h6 span {
  text-transform: capitalize;
}
</style>
